import * as Sentry from '@sentry/react-router';
import { createContext, useContext } from 'react';

export function contextFactory<TDefaultContext>(defaultValue?: TDefaultContext) {
  const context = createContext(defaultValue);

  function useCtx<TContext = TDefaultContext>() {
    const ctx = useContext(context);

    if (!ctx) {
      const error = new Error('useCtx must be used within a Provider');
      Sentry.captureException(error);
      throw error;
    }

    return ctx as TContext;
  }

  return [context, useCtx] as const;
}
